<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1200px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    class="live-mode-dialog"
    :class="{ flag: flag }"
    center
    :show-close="false"
  >
    <div slot="title" class="dialog-title">
      <p class="title">
        选择直播模式
        <img
          @click="showModeContrastPic"
          class="icon"
          src="../../../../assets/images/live-list/icon-why.png"
          alt=""
        />
      </p>
      <p class="tips">确认选择后模式不可变更</p>
      <img
        class="close-btn"
        src="@saas/components/assets/images/courseware/close.png"
        alt="关闭"
        @click="handleClose"
      />
    </div>
    <div class="dialog-content">
      <ul class="mode-list">
        <li
          @click="activeId = item.id"
          v-for="item in modeList"
          :key="item.id"
          class="mode-item"
          :class="{ 'active-item': item.id === activeId }"
        >
          <div>
            <svg
              width="26px"
              height="26px"
              class="right-icon"
              viewBox="0 0 26 26"
              version="1.1"
              v-if="item.id === activeId"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>对</title>
              <g
                id="🌟预告"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  class="svg-color"
                  id="选择直播模式"
                  transform="translate(-400, -926)"
                  fill="#00C89D"
                  fill-rule="nonzero"
                >
                  <g id="编组-3备份" transform="translate(54, 840)">
                    <g id="编组" transform="translate(40, 78)">
                      <g id="对备份-10" transform="translate(306, 8)">
                        <path
                          d="M13,26 C5.82075,26 0,20.17925 0,13 C0,5.82075 5.82075,0 13,0 C20.17925,0 26,5.82075 26,13 C26,20.17925 20.17925,26 13,26 Z M10.101,18.1046667 C10.3549658,18.3586994 10.6994575,18.5014192 11.0586667,18.5014192 C11.4178759,18.5014192 11.7623676,18.3586994 12.0163333,18.1046667 L20.2258333,9.89516666 C20.5679747,9.55302531 20.7015961,9.05434343 20.5763637,8.58696966 C20.4511312,8.11959589 20.0860708,7.75453543 19.618697,7.62930301 C19.1513232,7.50407058 18.6526413,7.63769199 18.3105,7.97983334 L11.0001667,15.1731667 L7.7285,11.9015 C7.38635865,11.5593587 6.88767677,11.4257372 6.420303,11.5509697 C5.95292923,11.6762021 5.58786875,12.0412626 5.46263633,12.5086363 C5.3374039,12.9760101 5.47102531,13.474692 5.81316666,13.8168333 L10.101,18.1046667 Z"
                          id="形状"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <p class="name">
              {{ item.name }}
              <img
                class="free-icon"
                v-if="item.freeTag"
                src="../../../../assets/images/live-list/limited-time-free.png"
                alt=""
              />
            </p>
            <p
              v-for="featureItem in item.feature"
              :key="item.id + featureItem"
              class="feature"
            >
              {{ featureItem }}
            </p>
            <div class="info">
              <p
                class="infor-item"
                v-for="(item, index) in item.info"
                :key="index"
              >
                <img
                  v-if="item.isHave"
                  src="../../../../assets/images/live-list/dui.png"
                  alt=""
                />
                <img
                  v-else
                  src="../../../../assets/images/live-list/error.png"
                  alt=""
                />
                <span>{{ item.text }}</span>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <live-mode-courseware
      v-if="flag"
      :fileList="fileList"
      ref="LiveModeCourseware"
    ></live-mode-courseware>

    <el-image
      ref="elImage"
      :style="'width: 0; height: 0;' + (flag ? ' display: none' : '')"
      src=""
      :preview-src-list="previewImages"
    >
    </el-image>

    <span slot="footer" class="dialog-footer">
      <button @click="handleClose" class="cancel-btn">取消</button>
      <button
        class="submit-btn"
        v-preventReClick
        :disabled="!Boolean(activeId)"
        @click="createRoom"
      >
        进入直播间
      </button>
    </span>
  </el-dialog>
</template>

<script>
import { createRoomByMode } from "@saas/service-api/src/live-list";
import { getCdnUrl } from "@saas/components/src";
import LiveModeCourseware from "./LiveModeCourseware.vue";
export default {
  components: {
    LiveModeCourseware,
  },
  data: function () {
    return {
      flag: false,
      activeId: 2,
      dialogVisible: false,
      normalClassModes: [
        {
          id: 1,
          name: "极速模式",
          feature: ["流量消耗少", "零延迟"],
          info: [
            {
              text: "课件展示",
              isHave: true,
            },
            {
              text: "语音互联",
              isHave: true,
            },
            {
              text: "白板",
              isHave: true,
            },
            {
              text: "单人上台",
              isHave: true,
            },
            {
              text: "摄像头",
              isHave: false,
            },
            {
              text: "屏幕分享",
              isHave: false,
            },
          ],
        },
        {
          id: 2,
          name: "高清模式",
          feature: ["全高清画质"],
          freeTag: true,
          info: [
            {
              text: "课件展示",
              isHave: true,
            },
            {
              text: "语音互联",
              isHave: true,
            },
            {
              text: "白板",
              isHave: true,
            },
            {
              text: "单人上台",
              isHave: true,
            },
            {
              text: "摄像头",
              isHave: true,
            },

            {
              text: "屏幕分享",
              isHave: true,
            },
          ],
        },
        {
          id: 3,
          name: "推流模式",
          feature: ["全高清画质", "支持 OBS"],
          info: [
            {
              text: "课件展示",
              isHave: true,
            },
            {
              text: "语音互联",
              isHave: true,
            },
            {
              text: "白板",
              isHave: false,
            },
            {
              text: "单人上台",
              isHave: true,
            },
            {
              text: "摄像头",
              isHave: true,
            },
          ],
        },
      ],
      smallClassModes: [
        {
          id: 1,
          name: "极速模式",
          feature: ["流量消耗少", "零延迟"],
          info: [
            {
              text: "课件展示",
              isHave: true,
            },
            {
              text: "语音互联",
              isHave: true,
            },
            {
              text: "白板",
              isHave: true,
            },
            {
              text: "多人上台",
              isHave: true,
            },
            {
              text: "摄像头",
              isHave: false,
            },
            {
              text: "屏幕分享",
              isHave: false,
            },
          ],
        },
        {
          id: 2,
          name: "互动模式",
          feature: ["多人视频上台"],
          info: [
            {
              text: "课件展示",
              isHave: true,
            },
            {
              text: "语音互联",
              isHave: true,
            },
            {
              text: "白板",
              isHave: true,
            },
            {
              text: "多人上台",
              isHave: true,
            },
            {
              text: "摄像头",
              isHave: true,
            },

            {
              text: "屏幕分享",
              isHave: true,
            },
          ],
        },
        {
          id: 3,
          name: "推流模式",
          feature: ["支持 OBS"],
          info: [
            {
              text: "课件展示",
              isHave: true,
            },
            {
              text: "语音互联",
              isHave: true,
            },
            {
              text: "白板",
              isHave: false,
            },
            {
              text: "多人上台",
              isHave: false,
            },
            {
              text: "摄像头",
              isHave: true,
            },
          ],
        },
      ],
      liveInfo: {},
      previewImages: [],
      classPreviewImages: [
        "",
        getCdnUrl("/cdn/static/images/big-class-mode.png", "?imageView2/0/w/900"),
        getCdnUrl("/cdn/static/images/small-class-mode.png", "?imageView2/0/w/900"),
      ],
      newClassPreviewImages: [
        "",
        getCdnUrl("/cdn/static/images/big-class-mode-new.png", "?imageView2/0/w/900"),
        getCdnUrl("/cdn/static/images/small-class-mode-new.png", "?imageView2/0/w/900"),
      ],
      fileList: [],
    };
  },
  methods: {
    showModeContrastPic() {
      const { course_type, is_new_live } = this.liveInfo;
      if (is_new_live === 1) {
        this.previewImages = [this.newClassPreviewImages[course_type]];
      } else {
        this.previewImages = [this.classPreviewImages[course_type]];
      }
      this.$refs.elImage.clickHandler();
    },
    createRoom() {
      this.pauseVideo();
      // this.$emit("createRooming", true);
      // console.log(
      //   this.$refs.LiveModeCourseware.fileList?.filter((item) => item.checked)
      // );
      const docIds =
        this.$refs.LiveModeCourseware?.fileList?.map((item) => item.id) || [];
      this.$saasLoadingShow();
      let { course_id, lesson_id } = this.liveInfo;
      let params = {
        course_id,
        lesson_id,
        doc_ids: docIds,
        mode: this.activeId,
      };
      createRoomByMode(params).then((res) => {
        if (res.code === 1) {
          this.liveInfo.mode = this.activeId;
          this.$emit("success", this.liveInfo);
          this.handleClose();
        } else if (res.code === 20020) {
          this.$saasLoadingClose();
          // this.$emit("createRooming", false);
          this.$confirm("果能点不足，请先充值再开课。", "提示", {
            center: true,
            confirmButtonText: "去充值",
            showCancelButton: false,
            type: "warning",
          }).then(() => {
            let url = `${process.env.VUE_APP_ADMIN_URL}/teaching/coin-detail?recharge=1`;
            if (this.liveInfo.course_type === 1) {
              url += "&type=1";
            } else {
              url += "&type=2";
            }
            if (window.isElectron) {
              window.openUrlByExternal(url);
            } else {
              window.open(url);
            }
          });
        } else if ([4444, 6666].includes(res.code)) {
          this.dialogVisible = false;
          this.$saasLoadingClose();
          // this.$emit("createRooming", false);
          if (res.code === 6666) {
            this.$showErrorPage({
              tips: "课程不存在",
            });
          } else {
            this.$showErrorPage();
          }
        } else if (res.code === 40013) {
          // 禁止开小班课
          this.$saasLoadingClose();
          this.dialogVisible = false;

          this.$nextTick(() => {
            this.$confirm(
              `<div style="text-align: center;display: flex;flex-direction: column;align-items: center;"><p style="font-size: 16px; color: #333;">暂时不支持，请联系运营人员</p>
              <img style="width: 160px; height: 160px; margin-top: 10px;" src="${getCdnUrl("/cdn/static/images/kehu_zixun_qrcode.png")}?t=${Date.now()}" alt="">
              </div>`,
              "",
              {
                center: true,
                confirmButtonText: "确定",
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                customClass: "saas-confirm-message",
                confirmButtonClass: "confirm-btn",
                cancelButtonClass: "cancel-btn",
              }
            );
          });
        } else {
          this.$message.error(res.message);
          this.$saasLoadingClose();
          // this.$emit("createRooming", false);
        }
      });
    },
    async openDialog(obj) {
      this.activeId = 2;
      this.flag = obj.is_new_live === 1;
      this.$nextTick(() => {
        this.flag &&
          this.$refs.LiveModeCourseware &&
          this.$refs.LiveModeCourseware.resetData();
      });
      if (window.isElectron) {
        // 判断是否在直播间
        let inRome = await window.ipcRenderer.invoke("judge-in-live-room", {
          showLiveTips: false,
        });
        if (inRome) {
          // 提示
          this.$message.warning(
            "暂不支持直接跳转，请离开当前直播间后再进入目标直播间"
          );
        } else {
          this.dialogVisible = true;
          this.liveInfo = obj;
        }
      } else {
        this.dialogVisible = true;
        this.liveInfo = obj;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.activeId = "";
      this.liveInfo = {};
      this.previewImages = [
        require("../../../../assets/images/mode-contrast.png"),
      ];
      this.pauseVideo();
    },
    pauseVideo() {
      if (this.$refs.LiveModeCourseware) {
        this.$refs.LiveModeCourseware.$refs?.videoRef?.pause();
      }
    },
  },
  computed: {
    modeList() {
      let temp = [];
      if (this.liveInfo.course_type === 1) {
        temp = this.normalClassModes;
      } else {
        temp = this.smallClassModes;
      }
      return this.flag ? temp.filter((item) => item.id !== 3) : temp;
    },
  },
};
</script>

<style lang="scss" scoped>
.live-mode-dialog {
  --live-mode-dialog-bg: var(--mg-bg-card);
  --live-mode-card-text: var(--mg-text-primary);
  --live-mode-secondary-text: var(--mg-text-secondary);
  --live-mode-subtle-bg: var(--mg-control-hover-bg);
  --live-mode-border: var(--mg-border-subtle);
  // These mode cards are branded illustrations, not neutral theme surfaces.
  --live-mode-card-1: linear-gradient(180deg, #daffee 0%, #f6fffd 100%);
  --live-mode-card-2: linear-gradient(180deg, #dafaff 0%, #f6fdff 100%);
  --live-mode-card-3: linear-gradient(180deg, #dfe3ff 0%, #f7f6ff 100%);
  --live-mode-feature-bg: #cffde8;
  --live-mode-feature-border: #87f9c8;
  --live-mode-feature-2-bg: #d2f9ff;
  --live-mode-feature-2-border: #8ef9ff;
  --live-mode-feature-3-bg: #d6dbff;
  --live-mode-feature-3-border: #b9c2ff;

  ::v-deep .el-dialog {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0 !important;
    height: 653px;
    background: var(--live-mode-dialog-bg);
    border-radius: 32px;
  }
  ::v-deep .el-dialog__header {
    padding-top: 60px;
  }
  ::v-deep .el-dialog__close {
    color: #4e5969;
    font-size: 14px;
    font-weight: bold;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 30px;
    right: 30px;
  }
  .dialog-title {
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 24px;
      color: var(--live-mode-card-text);
      line-height: 33px;
      .icon {
        margin-left: 8px;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
    }
    .tips {
      margin-top: 7px;
      font-weight: 400;
      font-size: 14px;
      color: var(--live-mode-secondary-text);
      line-height: 20px;
      text-align: center;
    }
    .close-btn {
      width: 22px;
      height: 22px;
      position: absolute;
      right: 27px;
      top: 27px;
      cursor: pointer;
    }
  }
  .mode-list {
    display: flex;
    justify-content: space-around;
    .mode-item {
      cursor: pointer;
      width: 320px;
      height: 317px;
      border-radius: 24px;
      padding: 30px 30px 0;
      position: relative;
      border: 2px solid transparent;
      border-bottom: 2px solid var(--live-mode-border);
      .name {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 24px;
        color: var(--live-mode-card-text);
        line-height: 33px;
        margin-bottom: 10px;
      }
      .feature {
        display: inline-block;
        margin-right: 14px;
        padding: 0 6px;
        height: 26px;
        background: var(--live-mode-feature-bg);
        border-radius: 6px;
        border: 1px solid var(--live-mode-feature-border);
        font-weight: 400;
        font-size: 14px;
        color: var(--live-mode-card-text);
        line-height: 24px;
      }
      .info {
        margin-top: 12px;
        font-weight: 400;
        font-size: 16px;
        color: var(--live-mode-card-text);
        line-height: 22px;
      }
      .infor-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }
      &::after {
        position: absolute;
        content: " ";
        display: block;
        width: 100px;
        height: 100px;
        right: 16px;
        bottom: 16px;
        background: url("../../../../assets/images/live-list/mode1.png");
        background-size: 100% 100%;
      }
      &:nth-child(1) {
        position: relative;
        background: var(--live-mode-card-1);
        &::after {
          background: url("../../../../assets/images/live-list/mode1.png");
          background-size: 100% 100%;
        }
        &.active-item {
          .right-icon .svg-color {
            fill: #00c89d;
          }
          border: 2px solid #4dffb3;
        }
      }
      &:nth-child(2) {
        background: var(--live-mode-card-2);
        &::after {
          background: url("../../../../assets/images/live-list/mode2.png");
          background-size: 100% 100%;
        }
        .feature {
          background: var(--live-mode-feature-2-bg);
          border: 1px solid var(--live-mode-feature-2-border);
        }
        &.active-item {
          .right-icon .svg-color {
            fill: #21c7e1;
          }
          border: 2px solid #2be3ff;
        }
      }
      &:nth-child(3) {
        background: var(--live-mode-card-3);
        &::after {
          background: url("../../../../assets/images/live-list/mode3.png");
          background-size: 100% 100%;
        }
        .feature {
          background: var(--live-mode-feature-3-bg);
          border: 1px solid var(--live-mode-feature-3-border);
        }
        &.active-item {
          .right-icon .svg-color {
            fill: #8d4eda;
          }
          border: 2px solid #93a0ff;
        }
      }
    }
  }
  .cancel-btn {
    width: 78px;
    height: 36px;
    background: var(--live-mode-subtle-bg);
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: var(--live-mode-card-text);
    line-height: 36px;
    margin-right: 16px;
  }
  .submit-btn {
    width: 100px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(
      132deg,
      $linear-gradient-begin 0%,
      $linear-gradient-end 100%
    );
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
  }
  .submit-btn:disabled {
    opacity: 0.5;
  }
  .free-icon {
    width: 42px;
    height: 20px;
    margin-left: 8px;
  }
  .right-icon {
    position: absolute;
    top: 8px;
    right: 8px;
  }
  &.flag {
    ::v-deep .el-dialog {
      height: 700px;

      .el-dialog__header {
        padding-top: 30px;
      }
      .dialog-title {
        display: flex;
        margin-left: 30px;
        .title {
          justify-content: left;
          margin-right: 10px;
        }
      }
      .el-dialog__body {
        padding: 0 25px 10px;
      }
      .feature {
        font-weight: 500;
      }
      .mode-list {
        justify-content: left;
        padding-left: 20px;
        gap: 40px;
        .mode-item {
          width: 340px;
          height: 171px;
          padding: 18px 24px;
          &::after {
            top: 8px;
            width: 75px;
            height: 75px;
          }
          .info {
            display: flex;
            flex-direction: row;
            gap: 0 6px;
            flex-wrap: wrap;
            .infor-item {
              width: 88px;
              font-size: 14px;
              margin-bottom: 6px;
            }
          }
        }
      }
    }
  }
}

html.dark .live-mode-dialog {
  --live-mode-dialog-bg: var(--mg-bg-elevated);
  --live-mode-card-text: var(--mg-text-primary);
  --live-mode-secondary-text: var(--mg-text-secondary);
  --live-mode-subtle-bg: var(--mg-control-hover-bg);
  --live-mode-border: var(--mg-border-subtle);
  --live-mode-card-1: linear-gradient(180deg, rgba(16, 185, 129, 0.22) 0%, rgba(15, 23, 42, 0.96) 100%);
  --live-mode-card-2: linear-gradient(180deg, rgba(6, 182, 212, 0.22) 0%, rgba(15, 23, 42, 0.96) 100%);
  --live-mode-card-3: linear-gradient(180deg, rgba(129, 140, 248, 0.22) 0%, rgba(15, 23, 42, 0.96) 100%);
  --live-mode-feature-bg: rgba(52, 211, 153, 0.16);
  --live-mode-feature-border: rgba(52, 211, 153, 0.38);
  --live-mode-feature-2-bg: rgba(34, 211, 238, 0.16);
  --live-mode-feature-2-border: rgba(34, 211, 238, 0.38);
  --live-mode-feature-3-bg: rgba(129, 140, 248, 0.16);
  --live-mode-feature-3-border: rgba(129, 140, 248, 0.38);
}
</style>
